import { useEffect, useState } from 'react';
import type { RefObject } from 'react';

/**
 * Observes an element's height via ResizeObserver and returns the measured
 * pixel value. Pass a ref attached to the wrapper element; use the returned
 * number as the explicit `height` prop on recharts' ResponsiveContainer
 * instead of "100%". This ensures charts correctly re-render when their
 * parent grid cell is resized inside react-grid-layout.
 */
export const useContainerHeight = (ref: RefObject<HTMLDivElement>): number => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const el = ref.current;

    if (!el) return;

    const observer = new ResizeObserver(([entry]) => {
      setHeight(entry.contentRect.height);
    });

    observer.observe(el);

    return () => observer.disconnect();
  }, [ref]);

  return height;
};
